import { createAction } from 'redux-act';

import { SelectedViewType } from '../../../store/reducers/ManagementPageReducer';

export interface ViewChangedPayload {
  selectedView: SelectedViewType;
}
export const viewChanged = createAction<ViewChangedPayload>('SELECTED_VIEW_CHANGED');
